export default __webpack_public_path__ + "static/media/highlighter.998491ab.png";